/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit ShowDeletedCheckbox/view.blocks to change it.
import * as fromData from 'Simple/Data'
import * as fromDesignTokens from 'Simple/DesignTokens'
import React from 'react'
import TysiaCheckbox from 'DesignSystem/TysiaCheckbox/index'
import TysiaCheckboxInput from 'DesignSystem/TysiaCheckbox/TysiaCheckboxInput/index'
import TysiaCheckboxText from 'DesignSystem/TysiaCheckbox/TysiaCheckboxText/index'



/** @type {import('Simple/types.js').View} */
export default function ShowDeletedCheckbox({
  children,
  viewPath = "/DesignSystem/ImageComparison/Content/Actions/Choose/ChooseImageAction/Content/Content/ShowDeletedCheckbox",
  onChange
  
}) {
let comparisonActionShowDeletedImageSeriesValueData = fromData.useDataValue({ viewPath,
context: 'comparison_action',
path: 'show_deleted_image_series',
})
let comparisonActionShowDeletedImageSeriesChangeData = fromData.useDataChange({ viewPath,
context: 'comparison_action',
path: 'show_deleted_image_series',
})
let dtSpaceXxs = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.xxs'
        })
let dtSpaceXs = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.xs'
        })
  return (<React.Fragment
>
<TysiaCheckbox
  viewPath={`${viewPath}/TysiaCheckbox`}
 marginLeft={dtSpaceXxs}
 marginBottom={dtSpaceXs}
 data="comparison_action.show_deleted_image_series"
 value={comparisonActionShowDeletedImageSeriesValueData}
 onChange={comparisonActionShowDeletedImageSeriesChangeData}
>
{childProps => (
<React.Fragment>
<TysiaCheckboxInput
{...childProps}
  viewPath={`${viewPath}/TysiaCheckboxInput`}
/>
<TysiaCheckboxText
{...childProps}
  viewPath={`${viewPath}/TysiaCheckboxText`}
 text="Show deleted image series"
/>
</React.Fragment>
)}
</TysiaCheckbox>
{children}
</React.Fragment>)
}